import { FunctionComponent } from 'react'
import { Box, Grid } from '@mui/material'
import {
  ObjectFieldProperty,
  useWidgetContext,
  WidgetDisplayMode,
} from '@dxp-module/common'
import objectFieldTemplateStyles from './objectFieldTemplate.styles'

type ObjectFieldProps = {
  properties: ObjectFieldProperty[]
  title: string
  idSchema: {
    $id: string
  }
}

const ObjectFieldTemplate: FunctionComponent<ObjectFieldProps> = props => {
  const styles = objectFieldTemplateStyles()
  const {
    configuration: { displayMode },
  } = useWidgetContext()
  const {
    properties,
    idSchema: { $id },
  } = props
  const isRoot = $id === 'root'

  return (
    <Grid container direction={isRoot ? 'column' : 'row'}>
      {properties?.map((field: ObjectFieldProperty, index: number) => {
        const fieldUiSchema = field?.content?.props?.uiSchema?.['ui:options']
        const isHidden = !!fieldUiSchema?.hide
        // Rows with a single field have a single string/boolean as form data and not objects as rows with multiple fields.
        const hasSingleField = ['string', 'boolean'].includes(
          typeof field?.content?.props?.formData
        )
        const rootGridClassName = hasSingleField
          ? displayMode === WidgetDisplayMode.AUTH_SCREEN
            ? styles.singleFieldMiniWidget
            : styles.singleField
          : styles.root

        if (isHidden) {
          return null
        }

        if (isRoot) {
          return (
            <Grid item xs={12} key={index} className={rootGridClassName}>
              <Box className={styles.content}>{field.content}</Box>
            </Grid>
          )
        }

        return (
          <Grid item key={index} xs={12} className={styles.child}>
            {field.content}
          </Grid>
        )
      })}
    </Grid>
  )
}

export default ObjectFieldTemplate
